export default __webpack_public_path__ + "static/media/Shiba.ebf3a559.svg";